export * from './information.component';
